/**
 * Кнопки копирования.
 *
 * На элементе `.copy-button` нужен атрибут `data-copytarget` — CSS-селектор
 * элемента, чей текст копируется.
 *
 * Пример:
 *   <button class="copy-button" data-copytarget="#phone">Копировать</button>
 *   <span id="phone">+7 925 461-71-29</span>
 *
 * После клика кнопка получает класс `.copy-button--is-copied` на 1.1s
 */
export function initCopyButtons() {
  document.querySelectorAll(".copy-button").forEach((btn) => {
    let canCopy = true;

    btn.addEventListener("click", async () => {
      if (!canCopy) return;
      canCopy = false;

      const selector = btn.dataset.copytarget;
      if (!selector) {
        console.error(".copy-button does not have a `data-copytarget` attribute", btn);
        canCopy = true;
        return;
      }

      const target = document.querySelector(selector);
      if (!target) {
        console.error(`Copy target for selector "${selector}" not found`);
        canCopy = true;
        return;
      }

      try {
        const item = new ClipboardItem({
          "text/plain": target.innerText,
        });
        await navigator.clipboard.write([item]);

        btn.classList.add("copy-button--is-copied");
        setTimeout(() => {
          btn.classList.remove("copy-button--is-copied");
          canCopy = true;
        }, 1100);
      } catch (err) {
        console.error("Copy failed:", err);
        canCopy = true;
      }
    });
  });
}
